// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,400;0,500;0,700;1,400;1,500;1,700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Google Sans", Roboto, RobotoDraft, Helvetica, Arial, sans-serif;
}

option {
  color: black;
}

/* Gmail-style font class */
.google-sans {
  font-family: "Google Sans", Roboto, RobotoDraft, Helvetica, Arial, sans-serif;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/App.css"],"names":[],"mappings":"AAGA;EACE,6EAA6E;AAC/E;;AAEA;EACE,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,6EAA6E;AAC/E","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,400;0,500;0,700;1,400;1,500;1,700&display=swap\");\n\n\nbody {\n  font-family: \"Google Sans\", Roboto, RobotoDraft, Helvetica, Arial, sans-serif;\n}\n\noption {\n  color: black;\n}\n\n/* Gmail-style font class */\n.google-sans {\n  font-family: \"Google Sans\", Roboto, RobotoDraft, Helvetica, Arial, sans-serif;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
